import { memo, useRef } from 'react'
import NavBarButton from '../NavBarButton/NavBarButton'
import Flag from 'LuxKit/Flag'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'
import useToggle from 'hooks/useToggle'
import { useAppSelector } from 'hooks/reduxHooks'
import { LANGUAGE_OPTIONS } from 'constants/languages'
import NavBarLanguageItems from './NavBarLanguageItems'

interface Props {
  className?: string
}

function NavBarLanguageButton(props: Props) {
  const [open, toggleOpen, _, closeDropdown] = useToggle()
  const locale = useAppSelector(state => state.geo.locale)
  const buttonRef = useRef<HTMLButtonElement>(null)

  const currentLanguage = LANGUAGE_OPTIONS.find(lang => lang.locale === locale) ?? LANGUAGE_OPTIONS[0]

  return <>
    <NavBarButton
      className={props.className}
      ref={buttonRef}
      icon={<Flag countryCode={currentLanguage.flagCode} size="S" />}
      onClick={toggleOpen}
      contentBreakpointMin="desktop"
    >
      {currentLanguage.nativeName}
    </NavBarButton>
    <DropdownList
      size="S"
      triggerRef={buttonRef}
      anchorRef={buttonRef}
      open={open}
      onClose={closeDropdown}
    >
      {open ? <NavBarLanguageItems /> : null}
    </DropdownList>
  </>
}

export default memo(NavBarLanguageButton)
